import { createSelector } from 'reselect'
import Fetch from '../constants/fetch-forgotpwd'
import FetchUserAppsStatus from '../constants/fetch-user-apps'
import ResendCodeTypes from '../constants/resend-code'
import SendChallengeStatus from '../constants/send-challenge'
import SubmitPasswordTypes from '../constants/password'
import SubmitVerificationTypes from '../constants/verification'
import resendMessage from '../constants/resend-message'
import FetchAccountRecovery from '../constants/fetch-account-recovery'


import {
    FETCH_DATA_ERROR,
    FETCH_DATA_SUCCESS,
    ON_NEXT,
    INIT,
    SESSION_TIMEOUT,
    SUBMIT_PASSWORD,
    SUBMIT_PASSWORD_SUCCESS,
    SUBMIT_PASSWORD_ERROR,
    INIT_USER_APPS,
    INIT_USER_APPS_ERROR,
    INIT_USER_APPS_SUCCESS,
    RESEND_CODE,
    RESEND_CODE_ERROR,
    RESEND_CODE_SUCCESS,
    SEND_CHALLENGE,
    SEND_CHALLENGE_ERROR,
    SEND_CHALLENGE_SUCCESS,
    SUBMIT_VERIFICATION_INIT,
    SUBMIT_VERIFICATION_INIT_SUCCESS,
    SUBMIT_VERIFICATION_INIT_ERROR,
    VERIFY_ACCOUNT_RECOVERY,
    VERIFY_ACCOUNT_RECOVERY_SUCCESS,
    VERIFY_ACCOUNT_RECOVERY_ERROR,
    GET_ACCOUNT_RECOVERY,
    GET_ACCOUNT_RECOVERY_SUCCESS,
    GET_ACCOUNT_RECOVERY_ERROR,
    ACCOUNT_RECOVERY_SELECTION
} from '../constants/forgotpwd'


export const initialState = {
    accountRecoveryData: [],
    accountRecoveryStatus: FetchAccountRecovery.DEFAULT,
    activeSession: false,
    data: {},
    error: null,
    resendSuccessMsg: resendMessage.DEFAULT,
    sessionTimeout: false,
    status: Fetch.SUCCESS,
    userData: {},
}

// Selectors
const selectRequestData = state => state.forgotPassword

const selectStateFor = key => createSelector(
    selectRequestData,
    (request = {}) => request[key]
)

export const selectActiveForgotPasswordSession = selectStateFor('activeSession')
export const selectAuthenticatorData = selectStateFor('authenticatorData')
export const selectAccountRecoveryData = selectStateFor('accountRecoveryData')
export const selectAccountRecoveryStatus = selectStateFor('accountRecoveryStatus')
export const selectErrorMessage = selectStateFor('error')
export const selectData = selectStateFor('data')
export const selectQRCodeData = selectStateFor('qrCodeData')
export const selectStatus = selectStateFor('status')
export const selectStep = selectStateFor('step')
export const selectAuthenticatorStatus = selectStateFor('authenticatorStatus')
export const selectForgotPasswordSessionTimeout = selectStateFor('sessionTimeout')
export const selectPasswordStatus = selectStateFor('passwordStatus')
export const selectQRCodeStatus = selectStateFor('qrCodeStatus')
export const selectResendCodeStatus = selectStateFor('resendCodeStatus')
export const selectVerificationStatus = selectStateFor('verificationStatus')
export const selectUserAppsData = selectStateFor('userAppsData')
export const selectUserAppStatus = selectStateFor('userAppsStatus')
export const selectSendChallengeData = selectStateFor('sendChallengeData')
export const selectSendChallengeStatus = selectStateFor('sendChallengeStatus')
export const selectUserData = selectStateFor('userData')
export const selectResendSuccessMsg = selectStateFor('resendSuccessMsg')

export default function forgotPassword(state = initialState, action) {
    switch (action.type) {

        case FETCH_DATA_ERROR:
            return {
                ...state,
                activeSession: false,
                error: action.payload,
                status: Fetch.ERROR,
                userData: {}
            }
        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                activeSession: true,
                error: null,
                status: Fetch.SUCCESS,
                step: 1,
                userData: { ...action.payload }
            }
        case INIT:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                status: Fetch.PENDING,
                userData: {}
            }
        case ON_NEXT:
            return {
                ...state,
                step: (state && state.step ? state.step + 1 : 0)
            }      
        case SUBMIT_PASSWORD:
            return {
                ...state,
                error: null,
                passwordStatus: SubmitPasswordTypes.PENDING
            }
        case SUBMIT_PASSWORD_ERROR:
            return {
                ...state,
                error: action.payload,
                passwordStatus: SubmitPasswordTypes.ERROR
            }
        case SUBMIT_PASSWORD_SUCCESS:
            return {
                ...state,
                passwordStatus: SubmitPasswordTypes.SUCCESS,
                step: 4
            }

        case INIT_USER_APPS:
            return {
                ...state,
                userAppsStatus: FetchUserAppsStatus.PENDING
            }
        case INIT_USER_APPS_SUCCESS:
            return {
                ...state,
                userAppsData: { ...action.payload },
                userAppsStatus: FetchUserAppsStatus.SUCCESS
            }
        case INIT_USER_APPS_ERROR:
            return {
                ...state,
                error: action.payload,
                userAppsStatus: FetchUserAppsStatus.ERROR
            }

        case RESEND_CODE:
            return {
                ...state,
                error: null,
                resendCodeStatus: ResendCodeTypes.PENDING,
                resendSuccessMsg: resendMessage.DEFAULT
            }
        case RESEND_CODE_ERROR:
            return {
                ...state,
                error: action.payload,
                resendCodeStatus: ResendCodeTypes.ERROR,
                resendSuccessMsg: resendMessage.DEFAULT
            }
        case RESEND_CODE_SUCCESS:
            return {
                ...state,
                resendCodeStatus: ResendCodeTypes.SUCCESS,
                resendSuccessMsg: resendMessage.SUCCESS,
                verificationStatus: ''
            }
        case SEND_CHALLENGE:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeStatus: SendChallengeStatus.PENDING
            }
        case SEND_CHALLENGE_ERROR:
            return {
                ...state,
                error: action.payload,
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeStatus: SendChallengeStatus.ERROR
            }
        case SEND_CHALLENGE_SUCCESS:
            return {
                ...state,
                data: { ...action.payload },
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeStatus: SendChallengeStatus.SUCCESS
            }

        case SUBMIT_VERIFICATION_INIT:
            return {
                ...state,
                verificationStatus: SubmitVerificationTypes.PENDING
            }
        case SUBMIT_VERIFICATION_INIT_ERROR:
            return {
                ...state,
                error: action.payload,
                verificationStatus: SubmitVerificationTypes.ERROR
            }
        case SUBMIT_VERIFICATION_INIT_SUCCESS:
            return {
                ...state,
                verificationStatus: SubmitVerificationTypes.SUCCESS
            }

        case VERIFY_ACCOUNT_RECOVERY:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                verificationStatus: SubmitVerificationTypes.PENDING
            }
        case VERIFY_ACCOUNT_RECOVERY_SUCCESS:
            return {
                ...state,
                error: null,
                verificationStatus: SubmitVerificationTypes.SUCCESS
            }
        case VERIFY_ACCOUNT_RECOVERY_ERROR:
            return {
                ...state,
                error: action.payload,
                verificationStatus: SubmitVerificationTypes.ERROR
            }
        case SESSION_TIMEOUT: {
            return {
                ...state,
                sessionTimeout: true
            }
        }
        case GET_ACCOUNT_RECOVERY:
            return {
                ...state,
                accountRecoveryData: [],
                accountRecoveryStatus: FetchAccountRecovery.PENDING,
            }
        case GET_ACCOUNT_RECOVERY_SUCCESS:
            return {
                ...state,
                accountRecoveryData: action.payload,
                accountRecoveryStatus: FetchAccountRecovery.SUCCESS,
            }
        case GET_ACCOUNT_RECOVERY_ERROR:
            return {
                ...state,
                accountRecoveryData: [],
                accountRecoveryStatus: FetchAccountRecovery.ERROR,
            }
        case ACCOUNT_RECOVERY_SELECTION:
            return {
                ...state,
                step: 2
            }
        default:
            return state

    }
}
